import { CommonSubmissionItemCardProps, SubmissionItemCard } from '@/components/AppStoreItems/AppStoreItemsCard';
import { antGrey } from '@/components/styles/globalStyles';
import { AppStoreReviewSubmissionItemType, AppVersionExperiment } from '@/types';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';

export interface AppVersionExperimentCardProps extends CommonSubmissionItemCardProps {
    appVersionExperiment: AppVersionExperiment;
}

export const AppVersionExperimentCard: React.FC<AppVersionExperimentCardProps> = ({
    appVersionExperiment,
    ...rest
}) => {
    return (
        <SubmissionItemCard
            item={appVersionExperiment}
            type={AppStoreReviewSubmissionItemType.AppStoreVersionExperiment}
            {...rest}
        >
            <Text style={{ fontWeight: 400, color: antGrey.grey9, fontSize: 14 }}>{appVersionExperiment.name}</Text>
            <div
                style={{
                    display: 'flex',
                    gap: 20,
                    width: '100%',
                    flexWrap: 'wrap',
                }}
            >
                <ul>
                    {appVersionExperiment.appVersionExperimentTreatments.map((treatment) => (
                        <li key={treatment.id}>
                            <Text style={{ fontWeight: 400, color: antGrey.grey7, fontSize: 14 }}>
                                {treatment.name}
                            </Text>
                        </li>
                    ))}
                </ul>
            </div>
        </SubmissionItemCard>
    );
};
